import React, {Component} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import tooltipLimiter from "@irati/recognition/utils/tooltipLimiter"

import Tooltip, {Tip} from "./Tooltip"

class UsersTooltip extends Component {
  getTooltip = (users) => {
    const names = users.map((user) => ({
      uuid: user.uuid,
      name: firstnameLastname(user)
    }))

    return (
      <Tip id={id("tooltip", this.props)}>
        {tooltipLimiter(names, this.props.intl).map(({uuid, name}) =>
          <div key={uuid}>
            {name}
          </div>
        )}
      </Tip>
    )
  }

  render() {
    const {users, children, ...tooltipProps} = this.props

    return (
      <Tooltip
        tip={this.getTooltip(users)}
        showMobile={false}
        {...tooltipProps}>
        {children}
      </Tooltip>
    )
  }
}

UsersTooltip.propTypes = {
  id: PropTypes.string,
  users: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

UsersTooltip.defaultProps = {
  id: "users_tooltip"
}

export default injectIntl(UsersTooltip)
